/**
 =========================================================
 * Material Kit 2 React - v2.0.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-kit-react
 * Copyright 2021 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components

// Material Kit 2 React components
// import MKTypography from "components/MKTypography";
import Grid2 from "@mui/material/Unstable_Grid2";

import Lightbox from "react-image-lightbox";
import { useState } from "react";
import MKBox from "../../../components/MKBox";
import MKButton from "../../../components/MKButton";

function AnalysisCard({ image, name, link }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);

  const handleImageClick = () => {
    setLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
  };
  return (
    <MKBox width={1}>
      <Grid2 container>
        <Grid2 xs={12}>
          <MKBox display="flex" justifyContent="center">
            <MKBox
              component="img"
              src={image}
              alt={name}
              width={1}
              borderRadius="md"
              zIndex={1}
              onClick={handleImageClick}
            />
            {lightboxOpen && (
              <Lightbox
                mainSrc={image}
                onCloseRequest={handleCloseLightbox} // Close the lightbox
              />
            )}
          </MKBox>
        </Grid2>
        <Grid2 xs={12}>
          <MKBox px={1}>
            {/* <MuiLink href={`/analysis/${link}`} target="_self" rel="noreferrer"> */}
            <MKButton
              color="primary"
              href={`/analysis/${link}`}
              variant="text"
              disableRipple
              sx={{ textTransform: "none", padding: 0 }}
            >
              {name}
            </MKButton>
            {/* </MuiLink> */}
          </MKBox>
        </Grid2>
      </Grid2>
    </MKBox>
  );
}

// Typechecking props for the LeftImageCard
AnalysisCard.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default AnalysisCard;
